import React from "react";
import { connect } from 'react-redux';
import { useQuery } from "react-query";
import { useQueryClient } from "react-query";

import { fetchAdministrationSAVCategories } from 'utils/queries';

import { postSAVCategorie, deleteSAVCategorie, patchSAVCategorie } from 'utils/posters';

import TextField from '@mui/material/TextField';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';


import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

//import LoadingButton from '@mui/lab/LoadingButton';
import LoadingButton from 'components/Shared/LoadingButton';
import QualificationTextField from 'components/Shared/QualificationTextField';

const actionsCellStyle = { wordWrap: "break-word", width: "120px" };

const Categories = ({ postSAVCategorie, deleteSAVCategorie, patchSAVCategorie }) => {

    const [creation, setCreation] = React.useState(false);

    const [libelle, setLibelle] = React.useState('');
    const [edited, setEdited] = React.useState(null);

    const [saving, setSaving] = React.useState(false);

    const [categorieToDelete, setCategorieToDelete] = React.useState(null);

    const queryClient = useQueryClient();
    const {
        isLoading,
        error,
        data,
    } = useQuery(
        ["AdministrationSAVCategories"],
        fetchAdministrationSAVCategories
    );


    const annulationCreation = () => {
        setCreation(false);
        setLibelle('');
    };
    const annulationEdition = () => {
        setLibelle('');
        setEdited(null);
    };


    const editer = (categorie) => {
        setLibelle(categorie.libelle);
        setEdited(categorie);
    };

    const post = async () => {
        setSaving(true);
        var result = await postSAVCategorie({ libelle });
        setSaving(false);


        if (result.error) {
            return;
        }

        setCreation(false);
        setLibelle('');
        queryClient.resetQueries("AdministrationSAVCategories");
    };

    const remove = async () => {
        setSaving(true);
        var result = await deleteSAVCategorie(categorieToDelete);
        setSaving(false);


        if (result.error) {
            return;
        }

        setCategorieToDelete(null);
        queryClient.resetQueries("AdministrationSAVCategories");
    };


    const patch = async () => {
        setSaving(true);
        var result = await patchSAVCategorie({ ...edited, libelle: libelle });
        setSaving(false);


        if (result.error) {
            return;
        }

        setLibelle("");
        setEdited(null);
        queryClient.resetQueries("AdministrationSAVCategories");
    };




    if (isLoading) {
        return (<p>Chargement en cours</p>);
    }

    if (error) {
        return (<p>Erreur du chargement des catégories SAV, veuillez contacter le support.</p>);
    }


    if (!data) {
        return null;
    }

    //console.log("Categories data=", data);

    return (
        <>

            <Table size='small'>
                <TableHead sx={{ backgroundColor: 'background.default' }}>
                    <TableRow>
                        <TableCell>Libellé</TableCell>
                        <TableCell style={actionsCellStyle}>Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <>


                        {!creation && (
                            <TableRow key={-1} hover>
                                <TableCell></TableCell>
                                <TableCell>
                                    <Button
                                        size="small"
                                        disabled={edited !== null}
                                        onClick={() => { setCreation(true); }}
                                        variant={"outlined"}
                                    >
                                        Nouvelle
                                    </Button>
                                </TableCell>
                            </TableRow>
                        )}




                        {creation && (
                            <TableRow key={-1} hover>
                                <TableCell>
                                    <QualificationTextField
                                        label="Libellé de la catégorie"
                                        autoFocus
                                        fullWidth
                                        style={{ paddingBottom: '0px' }}
                                        size="small"
                                        value={libelle}
                                        disabled={saving}
                                        onChange={e => { setLibelle(e.target.value); }}
                                    />
                                </TableCell>
                                <TableCell>
                                    {!saving && (
                                        <>
                                            <IconButton onClick={annulationCreation} color="error"><CancelIcon /></IconButton>
                                            <IconButton onClick={post} color="success" disabled={saving}><CheckCircleIcon /></IconButton>
                                        </>
                                    )}
                                    {saving && (<CircularProgress color="secondary" size={16} />)}
                                </TableCell>
                            </TableRow>
                        )}
                        {data.map(categorie => {

                            let edition = edited !== null && edited.id === categorie.id;

                            let showActions = edition || edited === null;

                            return (
                                <TableRow hover sx={showActions ? { "&:hover .MuiTableCell-root:last-child *:first-of-type": { display: 'inherit' } } : {}} key={categorie.id}>


                                    <TableCell>
                                        {!edition && (
                                            <>{categorie.libelle}</>
                                        )}
                                        {edition && (
                                            <QualificationTextField
                                                label="Libellé de la catégorie"
                                                autoFocus
                                                fullWidth
                                                style={{ paddingBottom: '0px' }}
                                                size="small"
                                                value={libelle}
                                                disabled={saving}
                                                onChange={e => { setLibelle(e.target.value); }}
                                            />
                                        )}                                        
                                    </TableCell>


                                    <TableCell sx={{ paddingTop: '0px', paddingBottom: '0px' }}>
                                        <Box sx={!edition ? { display: 'none' } : {}}>

                                            {!edition && (
                                                <>
                                                    <IconButton sx={{ paddingTop: '0px', paddingBottom: '0px' }} onClick={() => { editer(categorie); }} disabled={saving} size="small"><EditIcon fontSize="small" /></IconButton>
                                                    <IconButton sx={{ paddingTop: '0px', paddingBottom: '0px' }} onClick={() => { setCategorieToDelete(categorie) }} disabled={saving} size="small"><DeleteIcon fontSize="small" /></IconButton>
                                                </>
                                            )}


                                            {edition && (                                                
                                                <>

                                                    {!saving && (
                                                        <>
                                                            <IconButton onClick={annulationEdition} color="error"><CancelIcon /></IconButton>
                                                            <IconButton onClick={patch} color="success" disabled={!libelle || libelle === edited.libelle}><CheckCircleIcon /></IconButton>
                                                        </>
                                                    )}

                                                    {saving && (<CircularProgress color="secondary" size={16} />)}
                                                </>
                                            )}  
                                        </Box>
                                    </TableCell>



                                </TableRow>
                            );
                        })}
                    </>
                </TableBody>
            </Table>

            <Dialog open={categorieToDelete !== null}>

                <DialogContent>

                    {categorieToDelete && (<>

                        Souhaitez-vous vraiment supprimer la catégorie "<span style={{ fontWeight: 'bold' }}>{categorieToDelete.libelle}</span>" ?

                    </>)}     

                </DialogContent>

                <DialogActions>


                    <LoadingButton
                        pending={saving} 
                        onClick={remove}
                        variant="contained"
                        color="secondary"
                        label="Supprimer"
                    />
                    <Button
                        disabled={saving}
                        onClick={() => { setCategorieToDelete(null) }}
                    >
                        Annuler
                    </Button>

                </DialogActions>

            </Dialog>

        </>
    );

}




const mapDispatchToProps = {
    postSAVCategorie,
    deleteSAVCategorie,
    patchSAVCategorie
};

export default connect(null, mapDispatchToProps)(Categories);